module.exports = __webpack_public_path__ + "img/bg_role.2ac6f56b.jpg";